import {
  IFetchCitiesBySearchQueryResponse,
  IFetchCityByGPSCoordinatesResponse
} from "./cityService.types";
import wretch from "wretch";
import { generateUUID } from "utils/utils";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_API;

export const fetchCityBySearchParams = (
  searchQuery: string
): Promise<IFetchCitiesBySearchQueryResponse> => {
  return wretch(`${BASE_URL}/theseus/api/v1/cities?search=${searchQuery}`)
    .headers({
      "x-iq-request-id": generateUUID()
    })
    .get()
    .json();
};

export const getCityFromGPSCoordinates = (
  lat: number,
  long: number,
  userToken: string
): Promise<IFetchCityByGPSCoordinatesResponse> => {
  return wretch(
    `${BASE_URL}/theseus/api/v1/cities/reverse_geocode?lat=${lat}&long=${long}`
  )
    .headers({
      "x-iq-request-id": generateUUID()
    })
    .auth(`Bearer ${userToken}`)
    .get()
    .json();
};
